export const postFeed = ({ posts }) => {
  // Get All Posts
  const allPosts = posts;

  return {
    allPosts,
    postsPerPage: 5,
    page: 1,
    cardsDisplayed: undefined,
    mounted() {
      this.cardsDisplayed = this.postsPerPage;
    },
    loadMore() {
      if ((this.page + 1) * this.postsPerPage > this.allPosts.length) {
        this.cardsDisplayed = this.allPosts.length;
      } else {
        this.page++;
        this.cardsDisplayed = this.page * this.postsPerPage;
      }
    },
    filter(arr) {
      return arr.filter((p, i) => i < this.cardsDisplayed);
    },
    filterPostsBy(arr, key, value) {
      return arr.filter((p) => {
        p[key] === value;
      });
    },
    isMoreToLoad() {
      return this.cardsDisplayed < allPosts.length;
    },
  };
};
